if (!customElements.get('post-index')) {
  customElements.define(
    'post-index',
    class PostIndex extends HTMLElement {
      constructor() {
        super()

        this.content = this.querySelector('.content')
        this.indexContent = this.querySelector('.article__index-content')

        const headers = this.content.querySelectorAll('h2, h3');
        const headersObject = {};

        let lastH2;

        headers.forEach(header => {
          const uniqueId = 'post-header-' + Math.floor(Math.random() * 1000000);
          header.setAttribute('id', uniqueId);

          if (header.tagName === 'H2') {
            lastH2 = headersObject[uniqueId] = { href: `#${uniqueId}`, text: header.textContent, subitems: [] };
          } else if (header.tagName === 'H3' && lastH2) {
            lastH2.subitems.push({ href: `#${uniqueId}`, text: header.textContent, subitems: [] });
          }
        });

        const createHTML = items => items.map(item => `
          <li>
            <a href="${item.href}" class="link link--text">${item.text}</a>
            ${item.subitems.length > 0 ? `<ol>${createHTML(item.subitems)}</ol>` : ''}
          </li>`).join('');

        if (Object.keys(headersObject).length > 0) {
          const postIndexHtml = `
            <ol class="article__index-list">
              ${createHTML(Object.values(headersObject))}
            </ol>
          `;

          this.indexContent.innerHTML = postIndexHtml;
        }
      }
    }
  )
}
